import { UTCDate } from "map-wald";
import { TimePeriod } from "../data";



// @dynamic
export class TimePeriodUtils {
  static withinTimePeriod(date: UTCDate, timeperiod: TimePeriod): boolean {
    if(date.getTime()<timeperiod.from.getTime()){
      return false;
    }
    if((date.getUTCFullYear()==timeperiod.to.getUTCFullYear())&&
       (date.getUTCMonth()>timeperiod.to.getUTCMonth())){
        return false;
       }
    if(date.getUTCFullYear()>timeperiod.to.getUTCFullYear()){
      return false;
    }
    return true;
  }
  
  static makeLikeTimePeriods(timeperiod: TimePeriod, from: UTCDate, to: UTCDate): TimePeriod[] {
    const result:TimePeriod[] = [];
    const deltaYears = timeperiod.to.getUTCFullYear() - timeperiod.from.getUTCFullYear();
    const startYear = from.getUTCFullYear();
    const endYear = to.getUTCFullYear();
    for(var yr=startYear; yr <= endYear; yr++){
      if(yr===timeperiod.from.getUTCFullYear()){
        continue;
      }
      const tp:TimePeriod = {
        from: new Date(timeperiod.from.getTime()),
        to: new Date(timeperiod.to.getTime())
      };
      tp.from.setUTCFullYear(yr);
      tp.to.setUTCFullYear(yr+deltaYears);
      result.push(tp);
    }
  
    return result;
  }

  static durationInMonths(timeperiod:TimePeriod):number{
    let result = timeperiod.to.getUTCMonth() - timeperiod.from.getUTCMonth() + 1;
    if(result<=0){
      result += 12;
    }
    return result;
  }

  static moveToyear(timeperiod:TimePeriod, year:number):TimePeriod{
    const result:TimePeriod = {
      from: new Date(timeperiod.from.getTime()),
      to: new Date(timeperiod.to.getTime())
    };
    result.to.setUTCFullYear(year);
    result.from.setUTCFullYear(year-(timeperiod.to.getUTCFullYear()-timeperiod.from.getUTCFullYear()));
    return result;
  }

  static moveToMonth(timeperiod:TimePeriod, month:number):TimePeriod{
    const result:TimePeriod = {
      from: new Date(timeperiod.from.getTime()),
      to: new Date(timeperiod.to.getTime())
    };
    result.to.setUTCMonth(month);
    result.from.setUTCMonth(month-(timeperiod.to.getUTCMonth()-timeperiod.from.getUTCMonth()));
    return result;
  }

  static setDuration(timeperiod:TimePeriod, months:number):TimePeriod{
    const result:TimePeriod = {
      from: new Date(timeperiod.from.getTime()),
      to: new Date(timeperiod.to.getTime())
    };
    result.from.setUTCFullYear(result.to.getUTCFullYear());
    result.from.setUTCMonth(result.to.getUTCMonth()-(months-1));
    return result;
  }
}